import React, { useEffect} from "react";
import { ForgotPasswordSchema } from "../../../components/Helpers";
import { Formik, Form, Field } from "formik";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  requestForgotPassword,
  setResetForgotPassword,
} from "../../../Redux/LoginState/LoginActionCreator";
import TextInput from "../../../components/TextInput";
import Uni_Logo from "../../../Assets/DataCloud.jpeg";

function ForgotPasswordForm() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const ForgetPasswordState = useSelector(
    (state) => state.ForgotPasswordReducer
  );

  const forgotPassword = (values) => {
    dispatch(requestForgotPassword(values));
  };

  useEffect(() => {
    dispatch(setResetForgotPassword());
  }, []);
  
  useEffect(() => {
    if (ForgetPasswordState?.response && !ForgetPasswordState?.loading) {
      toast.success("Email Sent Successful");
    }
    if (ForgetPasswordState?.error && !ForgetPasswordState?.loading) {
      toast.error(ForgetPasswordState?.error?.errorData?.data || "unable to send email");
      
    }
  }, [ForgetPasswordState]);

  useEffect(() => {
    return () => {
      dispatch(setResetForgotPassword());
    };
  }, []);

  return (
    <div className="flex items-center justify-center w-[80vw] sm:w-[60vw] md:w-[20vw] p-3 md:px-5 bg-white rounded-2xl h-[50vh] sm:h-[55vh]">
      {!ForgetPasswordState?.response ? (
        <Formik
          
          initialValues={{
            email: "",
          }}
          validationSchema={ForgotPasswordSchema}
          onSubmit={(values, { setSubmitting }) => {
            forgotPassword(values);
            setSubmitting(false);
          }}
        >
          {({ errors, touched, values, handleChange, isSubmitting }) => (
            <Form className="shadow-none w-full h-full mt-5 sm:mt-10">
              <div className="text-center mb-6 sm:mb-8">
              <div className="flex items-center justify-center mb-4">
                <img src={Uni_Logo} alt="Logo" className="h-28 sm:h-32 w-auto object-contain hover:scale-105 transition-transform duration-300" />      
              </div>
                <h1 className="text-md sm:text-lg text-cyan-900 flex items-center justify-center mb-6 sm:mb-10">
                  Reset Password
                </h1>
              </div>

              <div className="mb-4">
                <TextInput
                  value={values.email}
                  name="email"
                  type="email"
                  placeholder="Email"
                  handleChange={handleChange}
                  legend
                  className="w-full border border-gray-300 rounded-[0.3rem] p-2 h-[2.4rem]"
                  bgColor="bg-white"
                  isDisabled={ForgetPasswordState.loading}
                />
                {errors.email && touched.email ? (
                  <p className="text-red-400">{errors.email}</p>
                ) : null}
              </div>
             <div className="flex items-center justify-center">
             <Link
                className="text-lg w-full font-medium text-primary px-4 py-1 rounded"
                to={"/Login"}
              >
                Sign In
              </Link>
              <button
                type="submit"
                disabled={ForgetPasswordState.loading || isSubmitting}
                className={`px-4 py-1 text-white font-medium text-lg rounded ${
                  ForgetPasswordState.loading || isSubmitting
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-primary hover:bg-primaryDark"
                }`}
              >
                {ForgetPasswordState.loading || isSubmitting ? (
                  <span className="flex items-center justify-center">
                    <svg
                      className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    Submitting...
                  </span>
                ) : (
                  "Submit"
                )}
              </button>
             </div>
            </Form>
          )}
        </Formik>
      ) : (
        <div>
          <p>Email has been sent to your registred Email address</p>
          <Link
            className="text-sm w-full font-medium text-primary px-4 py-1 rounded mr-2"
            to={"/login"}
          >
            Sign In Here
          </Link>
        </div>
      )}
    </div>
  );
}

export default ForgotPasswordForm;
